import { decorateWithTimestampsForFirestore } from './FirestoreUtils'
import moment from 'moment-timezone'
const REPORTS = '/locations/default/reports'

export default class ReportService {
  constructor (orgRef) {
    this.reports = orgRef.collection(REPORTS)
  }

  async getLastReport () {
    let snapshot = await this.reports.orderBy('created', 'desc').limit(1).get()
    if (snapshot.size > 0) {
      let report = snapshot.docs[0].data()
      report.previousDate = moment(report.created.toDate()).format('YYYY-MM-DD')
      report.previousTime = moment(report.created.toDate()).format('HH:mm')
      return report
    } else {
      return { fromDate: '', toDate: '', previousDate: '', previousTime: '' }
    }
  }

  addReport (date) {
    let report = {
      fromDate: moment(date.fromDate).format('YYYY-MM-DD'),
      toDate: moment(date.toDate).format('YYYY-MM-DD')
    }
    decorateWithTimestampsForFirestore(report)
    return this.reports.add(report)
  }
}
